import { getCredentials } from '@/utils/cognito';
import url from '@/utils/config';
import { useRouter } from 'next/router';
import { ReactNode, useLayoutEffect } from 'react';
import OrFooterArea from '../organisms/OrFooterArea';
import OrHeaderAreaWithLogin from '../organisms/OrHeaderAreaWithLogin';

/** 属性定義 */
type Props = {
  children: ReactNode;
  loginid: string;
};
const TemplateWithLogin = ({
  children,
  loginid
}: Props) => {
  const router = useRouter();
  useLayoutEffect(() => {
    // クレデンシャル情報がなければログイン画面に遷移させる
    if (getCredentials() === null) {
      window.location.href = url('/account/login');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [router.pathname]);
  return <div className='container'>
      <OrHeaderAreaWithLogin loginid={loginid} className='templateheader' />
      <div className='content'>{children}</div>
      <OrFooterArea className='templatefooter' />
    </div>;
};
export default TemplateWithLogin;